module.exports = __webpack_public_path__ + "static/media/G1-32-Norah-Kallis-cod67.aa919bb2.png";